/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from "formik";
import { useContext, useEffect, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { searchAllSimpleValue } from "../../../services/services";
import "../../../styles/index.scss";
import { INIT_VACCINE, listMuiTiem } from "../../constants/profileDialogConsts";
import { VaccineInfo } from "../../models/dialogModels";
import { addTiemChung, updateTiemChung } from "../../services/dialogServices";
import useMultiLanguage from "../../../../hook/useMultiLanguage";
import Autocomplete from "../../../components/input/autocomplete";
import TextValidator from "../../../components/input/text-validator";
import { handleBlurDate, hasAuthority } from "../../../utils/functionUtils";
import AppContext from "../../../../AppContext";
import moment from "moment";
import { useProfileContext } from "../../ProfileContext";
import { RESPONSE_STATUS_CODE, TYPE_CATEGORY } from "../../../constants/moduleConsts";
import { GroupButton } from "../../../components/GroupButton";
import { PERMISSIONS, PERMISSION_ABILITY } from "../../../../constants";
interface Props {
  open: boolean;
  handleClose: () => void;
  handleCloseAndSearch: () => void;
  identify: string;
  isView: boolean;
  dataSelect: VaccineInfo;
  lastDate?: string | null;
}
export const VaccinationDialog = (props: Props) => {
  const { open, dataSelect, handleClose, handleCloseAndSearch, identify, isView, lastDate } = props;
  const { lang } = useMultiLanguage();
  const { setPageLoading } = useContext(AppContext);
  const { isResign } = useProfileContext();

  const [isEdit, setIsEdit] = useState<boolean>(!isView);

  useEffect(() => {
    if (dataSelect?.id) {
      const dataUI = {
        ...dataSelect,
        phongBenh: dataSelect?.phongBenhId
          ? {
            id: dataSelect?.phongBenhId || "",
            value: dataSelect?.phongBenhText || ""
          }
          : null
      };
      formik.setValues(dataUI);
    } else {
      formik.setValues(INIT_VACCINE);
    }
  }, [dataSelect]);

  const handleFormSubmit = async (values: VaccineInfo) => {
    try {
      setPageLoading(true);
      const dataSubmit = {
        ...values,
        phongBenhId: values.phongBenh?.id || "",
        phongBenhText: String(values.phongBenh?.value || ""),
        employeeId: identify
      };
      const { data } = values?.id ? await updateTiemChung(values?.id, dataSubmit) : await addTiemChung(dataSubmit);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        toast.success(values.id ? lang("TOAST.EDIT.SUCCESS") : lang("TOAST.CREATE.SUCCESS"));
        handleCloseAndSearch();
      } else {
        toast.warning(data.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  };

  let validationSchema = Yup.object().shape({
    phongBenh: Yup.object().required(lang("VALIDATION.REQUIRE")).nullable(),
    muiTiem: Yup.object().required(lang("VALIDATION.REQUIRE")).nullable(),
    loaiVacxin: Yup.string().required(lang("VALIDATION.REQUIRE")).nullable(),
  });

  if (lastDate && !dataSelect?.id) {
    validationSchema = validationSchema.shape({
      ngayTiem: Yup.date()
        .required(lang("VALIDATION.REQUIRE"))
        .nullable()
        .min(moment(lastDate, "YYYY-MM-DD")
          .add(1, 'days'), lang("VALIDATE.NEXT_VACCINE_AFTER_LAST_VACCINE"))
    });
  } else {
    validationSchema = validationSchema.shape({
      ngayTiem: Yup.date()
        .required(lang("VALIDATION.REQUIRE"))
        .nullable()
    });
  }

  const formik = useFormik({
    initialValues: INIT_VACCINE,
    onSubmit: handleFormSubmit,
    validationSchema
  });

  const handleChangeSelect = (name: string, value: any) => {
    formik.setFieldValue(name, value);
  };

  return (
    <Modal
      show={open}
      size="xl"
      centered
      aria-labelledby="example-custom-modal-styling-title"
      onHide={handleClose}
      backdrop="static"
    >
      <Form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title
            id="example-custom-modal-styling-title"
            className="heading-5"
          >
            {lang("INPUT.VACCINATION")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12}>
              <Row className="px-8">
                <Col xs={4}>
                  <Autocomplete
                    isRequired
                    lable={lang("INPUT.VACCINATION.DISEASES")}
                    name="phongBenh"
                    isReadOnly={!isEdit}
                    value={formik.values?.phongBenh || null}
                    searchFunction={searchAllSimpleValue}
                    searchObject={{ type: TYPE_CATEGORY.phongBenh }}
                    onChange={(value) => handleChangeSelect("phongBenh", value)}
                    errors={formik.errors?.phongBenh}
                    touched={formik.touched?.phongBenh}
                    options={[]}
                    getOptionLabel={(options) => options?.value}
                  />
                </Col>
                <Col xs={4}>
                  <TextValidator
                    name="loVaccine"
                    lable={lang("INPUT.VACCINATION.CONSIGNMENT")}
                    type="text"
                    value={formik.values?.loVaccine || ""}
                    readOnly={!isEdit}
                    onChange={formik.handleChange}
                  />
                </Col>
                <Col xs={4}>
                  <TextValidator
                    isRequired
                    name="loaiVacxin"
                    lable={lang("INPUT.VACCINATION.KIND")}
                    type="text"
                    value={formik.values?.loaiVacxin || ""}
                    readOnly={!isEdit}
                    onChange={formik.handleChange}
                    errors={formik.errors?.loaiVacxin}
                    touched={formik.touched?.loaiVacxin}
                  />
                </Col>
                <Col xs={4} className="pt-6">
                  <Autocomplete
                    isRequired
                    lable={lang("INPUT.VACCINATION.COUNT")}
                    name="muiTiem"
                    value={formik.values?.muiTiem}
                    isReadOnly={!isEdit}
                    options={listMuiTiem}
                    onChange={(value) => handleChangeSelect("muiTiem", value)}
                    errors={formik.errors?.muiTiem}
                    touched={formik.touched?.muiTiem}
                  />
                </Col>
                <Col xs={4} className="pt-6">
                  <TextValidator
                    isRequired
                    name="ngayTiem"
                    lable={lang("INPUT.VACCINATION.DATE")}
                    type="date"
                    readOnly={!isEdit}
                    value={formik.values?.ngayTiem || ""}
                    onChange={formik.handleChange}
                    errors={formik.errors?.ngayTiem}
                    touched={formik.touched?.ngayTiem}
                    onBlur={() =>
                      handleBlurDate(
                        formik.setFieldValue,
                        formik.values?.ngayTiem,
                        "ngayTiem"
                      )
                    }
                  />
                </Col>
                <Col xs={4} className="pt-6">
                  <TextValidator
                    name="diaDiemTiem"
                    lable={lang("INPUT.VACCINATION.PLACE")}
                    type="text"
                    readOnly={!isEdit}
                    value={formik.values?.diaDiemTiem || ""}
                    onChange={formik.handleChange}
                    errors={formik.errors?.diaDiemTiem}
                    touched={formik.touched?.diaDiemTiem}
                  />
                </Col>
                <Col xs={4} className="pt-6">
                  <TextValidator
                    name="tinhTrangSkSauTiem"
                    lable={lang("INPUT.VACCINATION.STATUSAFTER")}
                    type="text"
                    readOnly={!isEdit}
                    value={formik.values?.tinhTrangSkSauTiem || ""}
                    onChange={formik.handleChange}
                  />
                </Col>
                <Col xs={4} className="pt-6">
                  <TextValidator
                    name="lanTiemTiepTheo"
                    lable={lang("INPUT.VACCINATION.NEXTTIME")}
                    type="date"
                    readOnly={!isEdit}
                    value={formik.values?.lanTiemTiepTheo || ""}
                    onChange={(e: any) => {
                      formik.handleChange(e);
                      let { value } = e.target;
                      if (moment(value).diff(formik.values.ngayTiem) < 0) {
                        formik.setFieldError(
                          "lanTiemTiepTheo",
                          "Lần tiêm tiếp theo phải lớn hơn ngày tiêm"
                        );
                      }
                    }}
                    onBlur={() =>
                      handleBlurDate(
                        formik.setFieldValue,
                        formik.values?.lanTiemTiepTheo,
                        "lanTiemTiepTheo"
                      )
                    }
                    errors={formik.errors?.lanTiemTiepTheo}
                    touched={formik.touched?.lanTiemTiepTheo}
                  />
                </Col>
                <Col xs={4} className="pt-6">
                  <TextValidator
                    name="luuY"
                    lable={lang("INPUT.VACCINATION.NOTE")}
                    type="text"
                    readOnly={!isEdit}
                    value={formik.values?.luuY || ""}
                    onChange={formik.handleChange}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="flex-center">
          <GroupButton type="btn-cancel" handleCloseUpdateDialog={handleClose} />
          {!isResign &&
            (isEdit ? (
              <GroupButton type="btn-save" />
            ) : (hasAuthority(PERMISSIONS.EMPLOYEE, PERMISSION_ABILITY.UPDATE) &&
              <GroupButton type="btn-edit" handleSaveEdit={() => setIsEdit(true)} />
            ))}
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
